import _ from 'lodash';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { Attachment, Emoji } from './shared/editor_action_buttons';
import CharacterCount from 'components/text_editor/character_count';
import Composer, { Header, HeaderText, useComposer } from './shared/composer';
import ComposerContext from 'components/composer/contexts/composer_context';
import connect from 'components/lib/connect';
import { EditorContainer, useEditor } from './shared/editor';
import FromField from './sms/from_field';
import MessagingEditor from './editors/messaging';
import PlaintextSerializer from 'components/text_editor/serializers/plaintext_serializer';
import SendSms from 'actions/composer/send_sms';
import ToField from './sms/to_field';

export function SmsComposer({ phoneNumbers }) {
  const composer = useComposer(SendSms);
  const editorProps = useEditor('bodyHtml', composer, { attr: 'body', serializer: PlaintextSerializer });
  const [composerProps] = composer;

  const { composition } = useContext(ComposerContext);
  const currentPhoneNumber = composition.content.to;
  const isInvalidNumber = !currentPhoneNumber || phoneNumbers.indexOf(currentPhoneNumber) === -1;

  return (
    <Composer disableSubmit={isInvalidNumber} includeAttachments submitText="Send" {...composerProps}>
      <Header>
        <Left>
          <HeaderText color="green400">SMS</HeaderText>
          <ToField isInvalidNumber={isInvalidNumber} phoneNumbers={phoneNumbers} />
        </Left>
        <Right>
          <Emoji {...editorProps} />
          <Attachment alwaysShow />
          <FromField />
        </Right>
      </Header>

      <EditorContainer includeAttachments>
        <MessagingEditor
          placeholder="Type to SMS"
          {...editorProps}
          onSubmit={isInvalidNumber ? _.noop : editorProps.onSubmit}
        />
        <CharacterCount {...editorProps} />
      </EditorContainer>
    </Composer>
  );
}

const Left = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`;
const Right = styled.div`
  align-items: center;
  display: flex;
`;

const SmsComposerConnected = connect(mapStateToProps)(SmsComposer);
export default SmsComposerConnected;

function mapStateToProps({ getProvider }) {
  const profile = getProvider('profile').get();

  return {
    phoneNumbers: profile ? profile.getSmsPhoneNumbers().map(number => number.normalized) : [],
  };
}
